/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow_down': {
    width: 16,
    height: 16,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M512 685.248L233.376 406.624l45.248-45.248L512 594.752l233.376-233.376 45.248 45.248z" _fill="#787878"/>'
  }
})
